import React, { FC, useCallback, useEffect, useState } from 'react';
import { useDispatch } from 'react-redux';

import { AdPreviewProps } from '$core/Ads/AdPreview/AdPreview.interface';
import { Button, Header, Placeholder, ScrollView } from '$uikit';
import { Api } from '$api';
import { toastActions } from '$store/toast';
import { Loader, PromoPost, PromoProfile } from '$shared/components';
import { useTranslator } from '$hooks';
import { goBack } from '$navigation/helper';
import classNames from 'classnames';

export const AdPreview: FC<AdPreviewProps> = ({ adId }) => {
  const dispatch = useDispatch();
  const t = useTranslator();
  const [loadingStatus, setLoadingStatus] = useState('loading');
  const [type, setType] = useState('');
  const [object, setObject] = useState<any>({});

  const loadData = useCallback(() => {
    setLoadingStatus('loading');
    Api.get<any, any>(`/ads/${adId}/info`)
      .then((data) => {
        setType(data.ads.objectType);
        setObject(data.object);
        setLoadingStatus('');
      })
      .catch((e) => {
        dispatch(toastActions.setToastFail(e.message));
        setLoadingStatus('failed');
      });
  }, [adId]);

  useEffect(() => {
    loadData();
  }, []);

  function renderContent() {
    if (loadingStatus === 'loading') {
      return <Loader isWrapped />;
    }

    if (loadingStatus === 'failed') {
      return (
        <Placeholder
          title={t('failed_title')}
          actions={
            <Button size="small" onClick={loadData}>
              {t('failed_button')}
            </Button>
          }
        >
          {t('failed_caption')}
        </Placeholder>
      );
    }

    if (type === 'profile') {
      return (
        <PromoProfile
          cover={object.cover}
          avatar={object.avatar}
          userId={object.ownerId}
          adId={0}
        />
      );
    } else if (type === 'promo_post') {
      return <PromoPost post={object} adId={0} />;
    }
  }
  return (
    <>
      <Header showBackButton backButtonOnClick={() => goBack()}>
        {t('ad_preview_title')}
      </Header>
      <ScrollView
        className={classNames({
          AdPreview: !window.adminPanel,
        })}
      >
        {renderContent()}
      </ScrollView>
    </>
  );
};
